/**
 * Marketing + app URLs for AmitaSoft blog chrome.
 */
const SOCIAL = {
  linkedin: "https://www.linkedin.com/company/amitasoft/",
  instagram: "https://www.instagram.com/amitasoft/",
  facebook: "https://www.facebook.com/amitasoft/",
  twitter: "https://x.com/amitasoft",
};

function resolveUrlsFromBuildEnv() {
  const landing = (process.env.REACT_APP_LANDING_URL || process.env.REACT_APP_BASE_URL || '').toLowerCase();
  if (!landing) return null;
  if (landing.includes('qa.dev.amitasoft')) {
    return devMarketingUrls();
  }
  if (landing.includes('qa.stage.amitasoft') || landing.includes('stage.amitasoft')) {
    return stageMarketingUrls();
  }
  if (landing.includes('amitasoft.com') && !landing.includes('qa.')) {
    return prodMarketingUrls();
  }
  return null;
}

export function getAmitasoftSiteUrls() {
  if (typeof window !== "undefined") {
    const host = window.location.hostname.toLowerCase();

    if (host.includes("qa.dev.amitasoft") || host.includes("dev.amitasoft")) {
      return devMarketingUrls();
    }
    if (host.includes("qa.stage.amitasoft") || host.includes("stage.amitasoft")) {
      return stageMarketingUrls();
    }
    if (host.includes("amitasoft.com")) {
      return prodMarketingUrls();
    }
  }

  return resolveUrlsFromBuildEnv() || devMarketingUrls();
}

function devMarketingUrls() {
  const base = "https://qa.dev.amitasoft.com";
  return {
    marketingHome: base,
    aboutUs: `${base}/#about`,
    products: `${base}/#products`,
    ourProducts: `${base}/#products`,
    contactUs: `${base}/contact-us`,
    scheduleDemo: `${base}/schedule-demo`,
    faq: `${base}/faq`,
    faqAnchor: `${base}/#faq`,
    thankYou: `${base}/thank-you`,
    notFound: `${base}/404`,
    termsConditions: `${base}/terms-conditions`,
    privacyPolicy: `${base}/privacy-policy`,
    signIn: "https://dev.kramasoft.com/signin",
    signUp: "https://dev.kramasoft.com/signup",
    blogHome: "/blog",
    blogPublicUrl: "https://qa.dev.amitasoft.com/blog",
    cliqloanHome: "https://qa.dev.cliqloan.com",
    amitasoftHome: "https://qa.dev.amitasoft.com",
    safevaultHome: "https://qa.dev.safevaultusa.com",
    social: SOCIAL,
  };
}

function stageMarketingUrls() {
  const base = "https://qa.stage.amitasoft.com";
  return {
    marketingHome: base,
    aboutUs: `${base}/#about`,
    products: `${base}/#products`,
    ourProducts: `${base}/#products`,
    contactUs: `${base}/contact-us`,
    scheduleDemo: `${base}/schedule-demo`,
    faq: `${base}/faq`,
    faqAnchor: `${base}/#faq`,
    thankYou: `${base}/thank-you`,
    notFound: `${base}/404`,
    termsConditions: `${base}/terms-conditions`,
    privacyPolicy: `${base}/privacy-policy`,
    signIn: "https://stage.amitasoft.com/signin",
    signUp: "https://stage.amitasoft.com/signup",
    blogHome: "/blog",
    blogPublicUrl: "https://qa.stage.amitasoft.com/blog",
    cliqloanHome: "https://qa.stage.cliqloan.com",
    amitasoftHome: "https://qa.stage.amitasoft.com",
    safevaultHome: "https://qa.stage.safevaultusa.com",
    social: SOCIAL,
  };
}

function prodMarketingUrls() {
  const base = "https://amitasoft.com";
  return {
    marketingHome: base,
    aboutUs: `${base}/#about`,
    products: `${base}/#products`,
    ourProducts: `${base}/#products`,
    contactUs: `${base}/contact-us`,
    scheduleDemo: `${base}/schedule-demo`,
    faq: `${base}/faq`,
    faqAnchor: `${base}/#faq`,
    thankYou: `${base}/thank-you`,
    notFound: `${base}/404`,
    termsConditions: `${base}/terms-conditions`,
    privacyPolicy: `${base}/privacy-policy`,
    signIn: "https://app.amitasoft.com/signin",
    signUp: "https://app.amitasoft.com/signup",
    blogHome: "/blog",
    blogPublicUrl: "https://www.amitasoft.com/blog",
    cliqloanHome: "https://www.cliqloan.com",
    amitasoftHome: "https://www.amitasoft.com",
    safevaultHome: "https://www.safevaultusa.com",
    social: SOCIAL,
  };
}
